import { DeliveryStatus } from '../../../../../../services/exports/Constants';

export default {
  title: 'Livraisons externes',
  fields: {
    pickup: 'Collecte',
    dropoff: 'Dépôt',
    status: 'Statut',
    estimated_time: 'Temps estimé',
    actual_time: 'Temps réel',
    actions: 'Actions',
    time: 'Heure',
    pickup_estimate: 'Estimation de collecte',
    dropoff_estimate: 'Estimation de dépôt',
  },
  labels: {
    pickup: 'Collecte',
    dropoff: 'Dépôt',
  },
  delivery_statuses: {
    [DeliveryStatus.Pending]: 'Chauffeur en attente',
    [DeliveryStatus.RunnerAssigned]: 'Chauffeur assigné',
    [DeliveryStatus.OnRoutePickup]: 'En route vers la collecte',
    [DeliveryStatus.ArrivedPickup]: 'Arrivé à la collecte',
    [DeliveryStatus.PickedUp]: 'Collecté',
    [DeliveryStatus.OnRouteDropoff]: 'En route vers le dépôt',
    [DeliveryStatus.ArrivedDropoff]: 'Arrivé au dépôt',
    [DeliveryStatus.Completed]: 'Terminé',
    [DeliveryStatus.Cancelled]: 'Annulé',
  },
  buttons: {
    actions: 'Actions',
    open_tracking_url: 'Suivre la livraison',
    show_order_details: 'Voir les détails de la commande',
    call_restaurant: 'Appeler le restaurant',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
  },
};
